import * as React from "react";
const SvgFiRrPlaneTail = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-plane-tail_svg__a)">
      <path
        fill="#062147"
        d="M22.61 16.085a86 86 0 0 0-4.225-1.401l3.077-11.539a2.48 2.48 0 0 0-.433-2.168A2.49 2.49 0 0 0 19.047 0h-.298a4.52 4.52 0 0 0-3.6 1.801l-5.851 7.8C8.124 11.166 6.342 12 5.506 12H1a1 1 0 1 0 0 2h2.008c6.901 0 14.818 2.484 18.924 3.966.029.011.069.025.068.096 0 .071-.04.085-.069.095-4.104 1.436-12.021 3.844-18.923 3.844H1a1 1 0 1 0 0 2h2.008c7.196 0 15.358-2.479 19.583-3.956A2.08 2.08 0 0 0 24 18.072a2.08 2.08 0 0 0-1.39-1.986zM10.899 10.8 16.75 3c.47-.626 1.218-1 2-1h.298a.49.49 0 0 1 .396.195.5.5 0 0 1 .087.434l-3.066 11.498c-2.246-.622-4.745-1.206-7.292-1.604a8.7 8.7 0 0 0 1.727-1.722zM8 19a1 1 0 1 1 0-2h5a1 1 0 1 1 0 2z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-plane-tail_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrPlaneTail;
